/**
 * Notification severity levels
 */
export enum NotificationSeverity {
  SUCCESS = 'success',
  DANGER = 'danger',
  WARNING = 'warning',
  INFO = 'info'
} 